// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2C4eg","bigColWidth":"Table_bigColWidth__3oqaq","biggerColWidth":"Table_biggerColWidth__37wsU","row":"Table_row__32Ov4","col":"Table_col__29qTf"};